<template>
  <c-radio-raw-base
    v-bind="{ ...$props, ...$attrs }"
    :value="modelValue"
    @input="$emit('update:modelValue', $event)"
  >
    <template
      v-for="(option, index) in options"
      v-slot:[`label-index-${index}`]="{ label }"
    >
      <slot
        :name="`label-index-${index}`"
        :label="label"
      />
    </template>

    <template #under-input>
      <slot name="under-input" />
    </template>
  </c-radio-raw-base>
</template>

<script>
import CRadioRawBase from './CRadioRaw'
import props from './props'

const { value, ...CRadioRawBaseProps } = props

export default {
  name: 'CRadioRaw',

  components: {
    CRadioRawBase
  },

  props: {
    ...CRadioRawBaseProps,

    modelValue: {
      type: [ String, Number, Boolean, Array, Object ],
      default: null
    }
  },

  emits: [
    'hint:show',
    'hint:hide',
    'update:modelValue',
    'input'
  ]
}
</script>
